/** See `src/i18n/locales/en/editions.ts`. */
export const editions = {
  fit: {
    sections: {
      home: 'Accueil',
      insights: 'Aperçus',
      programs: 'Programmes',
      content: 'Contenu',
    },
    items: {
      overview: "Vue d'ensemble",
      departments: 'Départements',
      users: 'Utilisateurs',
      vitality: 'Vitalité',
      participation: 'Participation',
      pilots: 'Pilotes',
      challenges: 'Défis',
      communications: 'Communication',
      documents: 'Documents',
      reports: 'Rapports',
      settings: 'Paramètres',
    },
  },
  soccer: {
    sections: {
      home: 'Accueil',
      insights: 'Aperçus',
      programs: 'Programmes',
    },
    items: {
      overview: "Vue d'ensemble",
      departments: 'Équipes',
      users: 'Joueurs',
      vitality: 'Vitalité',
      participation: 'Participation',
      pilots: 'Pilotes',
      challenges: 'Défis',
    },
  },
} as const;
